/* eslint-disable */
/* tslint:disable */
// @ts-ignore
import icon from 'vue-svgicon'
icon.register({
  'arrow-down-fine': {
    width: 16,
    height: 16,
    viewBox: '0 0 11 19',
    data: '<g _fill="none" fill-rule="evenodd"><g _fill="#FFF" fill-rule="nonzero"><path pid="0" d="M8.347 10.61a1 1 0 0 0 1.414 0 1.615 1.615 0 0 0 0-2.286L1.731.293A1 1 0 1 0 .316 1.707l7.813 7.814a1 1 0 0 0 .218 1.088v.001zm0-1.415L.293 17.249a1 1 0 0 0 1.414 1.414l8.054-8.054a1 1 0 0 0-1.414-1.414z"/></g></g>'
  }
})
